import styled from "styled-components";
import { blackColor, disabledColor, whiteColor } from "../../constants/colors";
import { SE_CLIENT_HEIGHT } from "../../constants/data";
import prevIcon from "./../../resources/images/prePaywall/arr_prev.png";
import nextIcon from "./../../resources/images/prePaywall/arr_next.png";

const PrepaywallBlock = styled.div``;

PrepaywallBlock.Items = styled.div`
  position: relative;
`;

PrepaywallBlock.Item = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  position: relative;
  z-index: 2;
`;

PrepaywallBlock.Item.Img = styled.div`
  img {
    width: 100%;
  }
`;
PrepaywallBlock.Item.Text = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

PrepaywallBlock.Line = styled.div`
  position: absolute;
  width: 8px;
  height: 90%;
  left: 29px;
  top: 20px;
  background: linear-gradient(
    180deg,
    #413c8c -6.1%,
    rgba(65, 60, 140, 0.42) 100%
  );
  opacity: 0.7;
`;

PrepaywallBlock.Preferences = styled.div`
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
`;
PrepaywallBlock.Preferences.Item = styled.div`
  padding: 0 10px;
  border-radius: 8px;
  margin-bottom: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 80px;
  background: #383063;
`;

PrepaywallBlock.Audio = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: nowrap;
`;

PrepaywallBlock.Audio.Item = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 22%;
  box-sizing: border-box;
`;

PrepaywallBlock.Audio.Item.Img = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
  margin-bottom: 10px;
  img {
    width: 100%;
    object-fit: cover;
  }
`;

PrepaywallBlock.Docs = styled.div`
  display: flex;
`;

PrepaywallBlock.Doc = styled.div`
  display: flex;
  flex-direction: column;
  width: 50%;
  align-items: center;
  img {
    max-width: 100%;
    :first-child {
      width: 73px;
      left: 6px;
      position: relative;
    }
  }
`;

PrepaywallBlock.Bottom = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  min-height: ${SE_CLIENT_HEIGHT}px;
  position: relative;
  overflow: hidden;
  background: ${blackColor};
  padding-top: 34px;
`;

PrepaywallBlock.Slider = styled.div`
  width: 100%;
  overflow: hidden;
  margin-bottom: -140px;
  .pre-paywall {
    &-bullets {
      width: 100%;
      height: 140px;
      background: linear-gradient(180deg, rgba(5, 2, 55, 0) 0%, #050237 100.2%);
      display: flex;
      justify-content: center;
      position: relative;
      top: -140px;
      align-items: flex-end;
      z-index: 2;
    }
    &-bullet {
      width: 7px;
      height: 7px;
      border-radius: 50%;
      background: ${disabledColor};
      margin-left: 8px;
      margin-right: 8px;
      transition: 0.3s;
      &.active {
        background: ${whiteColor};
      }
    }
  }
  .swiper-button-next {
    width: 32px !important;
    background-image: url(${nextIcon}) !important;
    background-repeat: no-repeat !important;
    background-size: contain !important;
    &:after {
      content: "" !important;
    }
  }
  .swiper-button-prev {
    width: 32px !important;
    background-image: url(${prevIcon}) !important;
    background-repeat: no-repeat !important;
    background-size: contain !important;
    &:after {
      content: "" !important;
    }
  }
`;

PrepaywallBlock.ButtonBlock = styled.div`
  position: fixed;
  padding-top: 27px;
  padding-bottom: 27px;
  background: none;
  width: 100%;
  bottom: 0;
  left: 0;
  z-index: 3;
`;

export { PrepaywallBlock };
